import {config} from '../config';
import {useEffect} from 'react';
import {TagManager} from '../lib/gtm/TagManager.ts';

type Props = {
    enabled: boolean;
};

export function useGtm({enabled}: Props) {
    useEffect(() => {
        if (enabled && TagManager.isConfigured()) {
            TagManager.initialize({
                source: `${config.sstUrl}${config.gtmLoaderPath}`,
                dataLayer: {
                    page: 'profile',
                },
            });
        }
    }, [enabled]);
}
